const PWD_COMPROMISED = 'PWD_COMPROMISED';
const USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS';

export const InvitationError = { PWD_COMPROMISED, USER_ALREADY_EXISTS };
